import axios from 'axios';
import { LIVE_LINK } from '../helpers/url_helper';
import { showToast } from '../components/Toast';

export const sendEmailWithExcel = (blob, clientName, invoice, carrier, realizationNo) => {
  return new Promise((resolve, reject) => {
    const file = new File([blob], `Заявка на отгрузку ${clientName} ${invoice}-${realizationNo}.xlsx`, { type: blob.type });
    const reader = new FileReader();

    console.time('File Conversion'); // Start timing

    reader.onloadend = async () => {
      console.timeEnd('File Conversion'); // Log conversion time
      const base64String = reader.result.split(',')[1]; // Convert to Base64

      try {
        console.time('Email Request'); // Start email request timing

        const response = await axios.post(
          `${LIVE_LINK}/email/sendEmail`,
          {
            file: base64String, // Send file as Base64
            filename: file.name, // Include filename
            carrier, // Add extra data
            clientName,
            invoice,
            realizationNo
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        );

        console.timeEnd('Email Request'); // Log email request time

        if (response.data.success) {
          // showToast('Email sent successfully!');
          resolve(response.data); // Resolve the Promise
        } else {
          showToast('Failed to send email.');
          reject(new Error('Email sending failed'));
        }
      } catch (error) {
        console.error('Error:', error);
        showToast('Error sending email.');
        reject(error); // Reject the Promise
      }
    };

    reader.readAsDataURL(file); // Convert File to Base64
  });
};
